import { Button } from "@mui/material";
import React from "react";
import "../inputField/inputField.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

function ButtonComponent({
  performClick,
  text,
  buttonStyle,
  disabled,
  isLoading,
}) {
  return (
    <button
      className="auth_button"
      style={buttonStyle}
      onClick={performClick}
      disabled={disabled}
    >
      {isLoading ? (
        <Spin
          indicator={<LoadingOutlined spin />}
          size="large"
          style={{ color: "white" }}
        />
      ) : (
        text
      )}
    </button>
  );
}

export default ButtonComponent;
